<template>
  <div id="captura-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE PLANIFICACION -->
              <v-card
                :key="cardPlanificacion"
                flat
                v-if="tabSelected == 'Planificacion'"
              >
                <planificacion
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></planificacion>
              </v-card>
              <!-- TAB DE EJECUCION -->
              <v-card
                :key="cardEjecucion"
                flat
                v-if="tabSelected == 'Ejecucion'"
              >
                <ejecucion
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></ejecucion>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Planificacion from "@/modules/aplicacion/views/captura/Planificacion.vue";
import Ejecucion from "@/modules/aplicacion/views/captura/Ejecucion.vue";

export default {
  name: "captura-sub-tab",

  components: {
    Planificacion,
    Ejecucion,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Planificacion", "Ejecucion"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
    cardPlanificacion: 0,
    cardEjecucion: 10,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Planificacion") {
        this.reloadPlanificacion();
      }
      if (this.tabSelected == "Ejecucion") {
        this.reloadEjecucion();
      }
    },
    reloadPlanificacion() {
      this.cardPlanificacion += 1;
    },
    reloadEjecucion() {
      this.cardEjecucion += 11;
    },
  },
};
</script>
